
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { useCashbackRules } from './useCashbackRules';

export const useCashbackToggle = () => {
  const [isToggling, setIsToggling] = useState(false);
  const { toast } = useToast();
  const { formData } = useCashbackRules();

  const toggleCashback = async (enabled: boolean) => {
    try {
      setIsToggling(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('Usuário não autenticado');

      if (enabled) {
        // Ativar: desativar todas as regras existentes e criar/ativar uma nova
        await supabase
          .from('cashback_rules')
          .update({ is_active: false })
          .eq('user_id', user.id);

        // Criar nova regra ativa baseada nos dados do formulário
        const { error } = await supabase
          .from('cashback_rules')
          .insert({
            user_id: user.id,
            percentage: parseFloat(formData.percentage) || 5.00,
            multiplier: parseInt(formData.multiplier) || 3,
            expiration_days: parseInt(formData.expiration_days) || 30,
            include_shipping: formData.include_shipping,
            is_active: true,
          });

        if (error) throw error;

      } else {
        // Desativar: marcar todas as regras como inativas
        const { error } = await supabase
          .from('cashback_rules')
          .update({ is_active: false })
          .eq('user_id', user.id);

        if (error) throw error;
      }

      toast({
        title: `Cashback ${enabled ? 'ativado' : 'desativado'}`,
        description: enabled ? 
          'O cashback padrão agora está funcionando normalmente.' : 
          'O cashback padrão foi pausado e não processará novas operações.',
      });

    } catch (error: any) {
      console.error('Error toggling cashback:', error);
      toast({
        title: "Erro ao alterar cashback",
        description: "Não foi possível alterar o status do cashback. Tente novamente.",
        variant: "destructive",
      });
    } finally {
      setIsToggling(false);
    }
  };

  return {
    toggleCashback,
    isToggling,
  };
};
